import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.hwhctherapy.com";

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "MedicalBusiness"],
  "@id": `${SITE_URL}/#business`,
  name: "Hope & Wellness Healing Center",
  url: SITE_URL,
  description:
    "Compassionate therapy services and professional office space for licensed mental health practitioners in Canton, Baltimore. Veteran-Owned and Black-Owned.",
  image: `${SITE_URL}/favicon.png`,
  email: "info@hwhctherapy.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "3500 Boston Street, Suite 432",
    addressLocality: "Baltimore",
    addressRegion: "MD",
    postalCode: "21224",
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 39.2776,
    longitude: -76.5669,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      opens: "07:00",
      closes: "22:00",
    },
  ],
  priceRange: "$$",
};

const HomepageSchema = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname !== "/") {
      const el = document.getElementById("localbusiness-jsonld");
      if (el) el.remove();
      return;
    }

    let script = document.getElementById("localbusiness-jsonld") as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = "localbusiness-jsonld";
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(localBusinessSchema);

    return () => {
      const el = document.getElementById("localbusiness-jsonld");
      if (el) el.remove();
    };
  }, [pathname]);

  return null;
};

export default HomepageSchema;
